import { render, staticRenderFns } from "./Feedlot.vue?vue&type=template&id=297bf9eb"
import script from "./Feedlot.vue?vue&type=script&lang=ts"
export * from "./Feedlot.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports